import {Component, OnInit, ViewChild} from '@angular/core';
import {HttpErrorResponse} from '@angular/common/http';
import {DatatableComponent} from '@swimlane/ngx-datatable';
import Swal from 'sweetalert2';
import {ToastrService} from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';
import {Router} from "@angular/router";
import {Subscription} from "rxjs";
import {SharedDataService} from "../../../../shared/services/shared-data.service";
import {SystemLicenseService} from "../../services/system-license.service";
import {SystemLicense} from "../../interface/system-license";

@Component({
  selector: 'app-system-license',
  templateUrl: './system-license.component.html',
  styleUrls: ['./system-license.component.scss']
})
export class SystemLicenseComponent implements OnInit {

  public systemLicenses!: SystemLicense[];

  public userPermissions = [];
  private permissionsSubscription: Subscription;

  temp = [];
  selected = [];
  public closeResult: string;
  public getDismissReason: string;
  public isButtonVisible = false;

  systemLicense = this.translate.instant('System License');
  product = this.translate.instant('product');

  are = this.translate.instant('are you sure?');

  rows = [];
  loadingIndicator = true;
  reorderable = true;
  @ViewChild(DatatableComponent) table: DatatableComponent;
  constructor(public systemLicenseService: SystemLicenseService,
              private sharedDataService: SharedDataService,
              private toast: ToastrService,
              private translate: TranslateService,
              private router: Router, ) {
    this.getSystemLicenseList();


    this.permissionsSubscription = this.sharedDataService.permissions.subscribe((data) => {
      this.userPermissions = data;
      console.log(data);
    });

  }

  ngOnInit() {
  }

  getSystemLicenseList(): any
  {
    this.systemLicenseService.getCollection().subscribe({
      next: (res: any) => {
        console.log(res);
        this.systemLicenses = res['hydra:member']
        // this.SystemLicensees = res['hydra:member'][0].table;

        console.log(this.systemLicenses);

        // cache our list
        // this.temp = [...res['hydra:member']];
        this.temp = [...res['hydra:member']];

        this.rows = this.systemLicenses;

        this.loadingIndicator = false;
      },
      error: (error: HttpErrorResponse) => {
        console.log(error.message);
        console.log('Error while fetching the records');
        this.loadingIndicator = false;
      }
    });
  }

  onSelect({ selected }) {
    console.log('Select Event', selected, this.selected);
    console.log(this.selected);

    this.selected.splice(0, this.selected.length);
    this.selected.push(...selected);

     this.isButtonVisible = this.selected.length > 0;
  }

  onActivate(event) {
    console.log('Activate Event', event);
  }

  add() {
    this.selected.push(this.rows[1], this.rows[3]);
  }

  update() {
    this.selected = [this.rows[1], this.rows[3]];
  }

  remove() {
    this.selected = [];
  }

  displayCheck(row) {
    return row.name !== 'Ethel Price';
  }

  edit(row: any) {
  }

  delete(row: any) {

  }

  toggleExpandRow(row) {
    console.log('Toggled Expand Row!', row);
    this.table.rowDetail.toggleExpandRow(row);
  }

  onDetailToggle(event) {
    console.log('Detail Toggled', event);
  }

  addSystemLicense(): void {
    this.router.navigate(['/security/system-license/add']);
  }
  editSystemLicense(id: number): void {
    this.router.navigate(['/security/system-license/edit', id]);
  }

  deleteSystemLicense(id: number): any{
    Swal.fire({
      title: this.translate.instant('are you sure?'),
      text: this.translate.instant('you won\'t be able to revert this!'),
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: this.translate.instant('yes, delete it!'),
    }).then((result) => {
      if (result.isConfirmed) {
        this.loadingIndicator = true;
        this.systemLicenseService.delete(id).subscribe({
          next: (res) => {
            this.toast.success(this.translate.instant('system license') + ' ' + this.translate.instant('deleted') + ' ' + this.translate.instant('successfully!'), 'Success');
            this.getSystemLicenseList();
          },
          error: (res) => {
            this.loadingIndicator = false;
            this.toast.error(res['hydra:title'], 'Error');
          }
        });
      }
    });
  }

  deleteSelectedSystemLicenseRows() {
    Swal.fire({
      title: this.translate.instant('are you sure you want to delete ') + this.selected.length + this.translate.instant(' line(s) ?'),
      text: this.translate.instant('you won\'t be able to revert this!'),
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: this.translate.instant('yes, delete it!'),
    }).then((result) => {
      if (result.isConfirmed) {
        this.loadingIndicator = true;

        const obj = this.selected;
        const vals = Object.values(obj);
        const ids = vals.map(a => (a.id));
        this.systemLicenseService.deleteMultiple(ids).subscribe({
          next: (res) => {
            console.log(res);
            this.toast.success(this.translate.instant('system license') + ' ' + this.translate.instant('deleted') + ' ' + this.translate.instant('successfully!'), 'Success');
            this.getSystemLicenseList();
            this.remove();
          },
          error: (err: any) => {
            console.log(err);
          }
        });

      }
    });

  }

  updateFilter(event) {
    const val = event.target.value.toLowerCase();
    this.rows = this.temp.filter(function(d) {
      return d && (d.name.toLowerCase().indexOf(val) !== -1 || !val);
    });
    this.table.offset = 0;
  }

  ngOnDestroy(): void {
    this.permissionsSubscription.unsubscribe();
  }

}
